angular.module('app.api').factory('ApplicationsApi', [
  'api',
  function ApplicationsApi(api) {
    const applicationApi = {
      getApplicationListing: payload => {
        return api.get(`listings/application`, {params: payload})
      },
      updateApplicationById: (id, payload) => {
        return api.put(`applications/${id}`, payload)
      },
      getApplicationById: id => {
        return api.get(`application/${id}`)
      },
      deleteApplicationById: id => {
        return api.delete(`applications/${id}`)
      },
      createApplication: payload => {
        return api.post(`applications`, payload)
      },
      bulkApplicationUpdate: payload => {
        return api.put(`bulk/applications`, payload)
      },
      getApplicationResume: id => {
        return api.get(`applications/${id}/resume`)
      },
      getApplicationHistoryById: id => {
        return api.get(`applications/${id}/history`)
      },
    }
    return applicationApi
  },
])



// WEBPACK FOOTER //
// ./scripts/admin-panel/application-listing/applications.api.js